import React from 'react';
// import ProductViewer from '../product-viewer/ProductViewer';
import IconRotate from '../../../static/icons/icon_rotate_image.svg';

const WhoWeAreCard = () => {
    // const jerseysPath = '/jerseys-360';
    // const jerseyYear = '2021_2022';
    // const jerseyTeam = 'fpf';
    // const jerseyLocation = 'home';
    // const jerseyImagesAmount = 122;

    return (
        <div className="card">
            <div className="flex flex-col lg:flex-row lg:space-x-10 justify-between">
                <div className="flex flex-col space-y-6 w-full lg:w-1/2">
                    <h1 className="card-title">
                        {/* Share a memory, tell stories️ */}
                        The 2.0 Collectible
                    </h1>
                    <span className="text-card-text-color xl:w-9/12">
                        {/* With FanCollex® you will be able to mark milestones in the
                        club's history thanks to the reliable reproductions of
                        full kits and jerseys. Collectors and fans will be able
                        to keep a unique and detailed memento from a particular
                        season or competition to share with future generations. */}
                        The MyJersey is a Vinyl sport collectible with Augmented Reality (AR) 
                        Technology associated with and accessible through our mobile application. 
                        Perfect for fans and collectors, with our official and detailed mementos, 
                        anyone can relive a particular season or competition and share it with 
                        future generations.
                    </span>
                </div>
                <div className="lg:w-1/2 h-125 -mt-10">
                    <model-viewer
                        src="/models/ronaldo.glb"
                        ios-src="/models/ronaldo.usdz"
                        poster="/jerseys-360/model-viewer/fpf/poster_ronaldo.webp"
                        alt="Jersey Product"
                        loading="eager"
                        ar
                        disable-zoom
                        ar-modes="webxr scene-viewer quick-look"
                        environment-image="neutral"
                        auto-rotate
                        rotation-per-second="-300%"
                        camera-controls
                        camera-orbit="25.48deg 70.66deg auto"
                        touch-action="none"
                        quick-look-browsers="safari chrome"
                    ></model-viewer>
                    {/* <ProductViewer
                        amount={jerseyImagesAmount}
                        imagePath={`${jerseysPath}/${jerseyYear}/${jerseyTeam}/${jerseyLocation}`}
                        fileName="{index}.png"
                        indexZeroBase="1"
                    /> */}
                </div>
            </div>
            <div className="flex items-center justify-center lg:justify-start space-x-7 ">
                <img src={IconRotate} alt="Rotate to explore" />
                <span className="text-card-text-color text-14">
                    Rotate image to explore
                </span>
            </div>
        </div>
    );
};

export default WhoWeAreCard;
